import { Component, ViewChild } from "@angular/core";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { AuthService } from "../../auth/auth.service";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { map, Observable, Subject, takeUntil, tap } from "rxjs";
import { IUser, routeList } from "../../models";
import { commonEnv } from "src/environments/environment.common";
import { CommonModule } from "@angular/common";
import { MatSidenav, MatSidenavModule } from "@angular/material/sidenav";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatButtonModule } from "@angular/material/button";
import { MatListModule } from "@angular/material/list";
import { MatIconModule } from "@angular/material/icon";
import { GravatarModule } from "ngx-gravatar";
import { MatRippleModule } from "@angular/material/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatExpansionModule } from "@angular/material/expansion";
import { animate, style, transition, trigger } from "@angular/animations";
import { ApplicationStatusObject } from "../../models";
import { StoreService } from "src/app/services-store/store.service";

@Component({
    selector: "app-main-nav",
    imports: [
        CommonModule,
        MatSidenavModule,
        MatToolbarModule,
        MatButtonModule,
        MatListModule,
        MatIconModule,
        MatExpansionModule,
        MatTooltipModule,
        MatRippleModule, // Optional
        GravatarModule,
    ],
    templateUrl: "./main-nav.component.html",
    styleUrls: ["./main-nav.component.scss", "./main-nav.component.css"],
    animations: [
        trigger("toolbarAnimation", [
            transition(":enter", [
                style({ opacity: 0, transform: "translateY(-100%)" }),
                animate("300ms ease-in", style({ opacity: 1, transform: "translateY(0)" })),
            ]),
            transition(":leave", [
                animate("300ms ease-out", style({ opacity: 0, transform: "translateY(-100%)" })),
            ]),
        ]),
        trigger("iconAnimation", [
            transition("void => *", [
                style({ transform: "rotate(0deg)" }),
                animate("300ms ease-in-out", style({ transform: "rotate(180deg)" })),
            ]),
            transition("* => void", [
                animate("300ms ease-in-out", style({ transform: "rotate(0deg)" })),
            ]),
        ]),
    ]
})
export class MainNavComponent {
  user: IUser;
  isAtHomeScreen = false;
  destroyed$ = new Subject<void>();
  applicationId: string;

  isHandset$: Observable<boolean>;
  isExpanded: boolean;
  isOpened: boolean;
  applicationStatusObject = ApplicationStatusObject;
  public applicationStatus = ApplicationStatusObject.unknown.text;

  @ViewChild("drawer")
  drawer!: MatSidenav;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private store: StoreService
  ) {
    this.isHandset$ = this.breakpointObserver
      .observe([Breakpoints.Handset, Breakpoints.Tablet])
      .pipe(
        map((result) => {
          // console.log(result.breakpoints);

          if (result.matches && window.innerWidth < 1280) {
            // console.log("screen width is:" + window.innerWidth);
            // console.log("handheld or tablet detected");
            return true;
          }

          // console.log("desktop detected");
          return false;
        }),
        takeUntil(this.destroyed$)
      );
    this.user = this.authService.getUserInfo();
  }

  ngOnInit() {
    this.getAppInfo();
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.isAtHomeScreen =
          val.urlAfterRedirects ===
          `/${routeList.agent.path}/${routeList.agent.children.applicationList}`;
      }
    });
  }

  public getAppInfo() {
    try {
      this.store.applicantInfoStore
        .selectApplicantInfo()
        .pipe(
          takeUntil(this.destroyed$),
          tap((currentAppInfo) => {
            if (currentAppInfo) {
              this.applicationId = currentAppInfo.appId;
              if (currentAppInfo.status) {
                Object.entries(this.applicationStatusObject).forEach(
                  (object) => {
                    if (object[1].value === currentAppInfo.status) {
                      this.applicationStatus = object[1].text;
                    }
                  }
                );
              } else {
                this.applicationStatus = this.applicationStatusObject.new.text;
              }
            }
          })
        )
        .subscribe();
    } catch (err) {}
  }

  public ToogleHeader() {
    if (this.drawer.mode === "over") {
      this.drawer.opened = !this.drawer.opened;
    }
  }

  public ToggleSideNav() {
    if (this.drawer.mode !== "over") {
      this.isExpanded = !this.isExpanded;
    }
  }

  onHomeClick = () => {
    const user = this.authService.getUserInfo();
    if (user) {
      user.tfp === commonEnv.agentSignInPolicy
        ? this.router.navigateByUrl(`/${routeList.agent.path}`)
        : this.router.navigateByUrl(
            `/${routeList.application.path}/${routeList.application.children.personalInfo}`
          );
    }
  };

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.unsubscribe();
  }

  onSignOutClick() {
    this.authService.logout();
  }
}
